import {
  MarketDependent,
  Spaceable
} from "./chunk.SHDHDUWS.js";
import {
  Linkable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.VPBTB6HE.js";
import {
  __decorateClass
} from "./chunk.7VONTVYH.js";

// src/components/jb-in-text-teaser/jb-in-text-teaser.ts
import { html, LitElement, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

// src/components/jb-in-text-teaser/jb-in-text-teaser.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_in_text_teaser_default = css`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* stylelint-disable */
/* stylelint-enable */
h4 {
  font-family: VerlagSSm, Tahoma, sans-serif;
  font-weight: 700;
}

p, h3 {
  font-family: VerlagSSm, Tahoma, sans-serif;
  font-style: normal;
  font-weight: 300;
}

h3 {
  font-size: 22px;
  line-height: 28px;
}
@media (min-width: 1281px) {
  h3 {
    font-size: 26px;
    line-height: 36px;
  }
}

p {
  font-size: 17px;
  line-height: 30px;
}
@media (min-width: 1281px) {
  p {
    font-size: 19px;
    line-height: 34px;
  }
}

h4 {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 11px;
  letter-spacing: 1px;
  line-height: 16px;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
:host {
  color: var(--host-color, #141e55);
}

section {
  border-block: 1px solid rgba(20, 30, 85, 0.2);
  padding-block: 16px 24px;
}
@media (min-width: 600px) {
  section {
    clip-path: inset(0 20px);
    display: flex;
    padding-top: 20px;
  }
}
@media (min-width: 960px) {
  section {
    clip-path: inset(0 calc(16.6666666667% + 20px));
    padding-top: 24px;
  }
}
@media (min-width: 1281px) {
  section {
    padding-block: 40px;
  }
}

a {
  text-decoration: none;
}

h3 {
  margin-bottom: 8px;
}

h4 {
  color: rgba(20, 30, 85, 0.4);
  text-transform: uppercase;
}

.image-wrap {
  margin-bottom: 16px;
}
@media (min-width: 600px) {
  .image-wrap {
    box-sizing: border-box;
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
    padding: 0 20px;
    width: 33.3333333333%;
    margin-bottom: 0;
  }
}
@media (min-width: 960px) {
  .image-wrap {
    margin-left: 16.6666666667%;
    box-sizing: border-box;
    flex-basis: 25%;
    max-width: 25%;
    padding: 0 20px;
    width: 25%;
  }
}
@media (min-width: 1281px) {
  .image-wrap {
    margin-left: 16.6666666667%;
    box-sizing: border-box;
    flex-basis: 25%;
    max-width: 25%;
    padding: 0 20px;
    width: 25%;
  }
}

.no-image .text-wrap {
  margin-left: 16.6666666667%;
  box-sizing: border-box;
  flex-basis: 66.6666666667%;
  max-width: 66.6666666667%;
  padding: 0 20px;
  width: 66.6666666667%;
  text-align: center;
}

@media (min-width: 600px) {
  .text-wrap {
    box-sizing: border-box;
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    padding: 0 20px;
    width: 66.6666666667%;
  }
}
@media (min-width: 960px) {
  .text-wrap {
    box-sizing: border-box;
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    padding: 0 20px;
    width: 41.6666666667%;
  }
}

a p {
  margin-bottom: 24px;
}

header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
header > div {
  --stroke-color: rgba(20, 30, 85, 0.4);
  display: flex;
}
@media (min-width: 600px) {
  header {
    padding-inline: 20px;
  }
}
@media (min-width: 960px) {
  header {
    box-sizing: border-box;
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    padding: 0 20px;
    width: 66.6666666667%;
    margin-left: 16.6666666667%;
  }
}

h3,
p {
  margin-bottom: 8px;
}
@media (min-width: 1281px) {
  h3,
  p {
    margin-bottom: 16px;
  }
}

p.text-placeholder {
  background-color: rgba(20, 30, 85, 0.05);
  height: 30px;
}
p.text-placeholder.short {
  width: 50%;
}
p.text-placeholder.button {
  height: 36px;
  margin-top: 23px;
  width: 33%;
}

@media print {
  :host {
    display: none;
  }
}
jb-globe-icon {
  display: inline-block;
  height: 1rem;
  margin-right: 4px;
  width: 1rem;
}`;

// src/components/jb-in-text-teaser/jb-in-text-teaser.ts
var JbInTextTeaser = class extends Linkable(MarketDependent(Spaceable(LitElement))) {
  firstUpdated() {
    if (!this.link) {
      this.style.setProperty("display", "none");
    }
  }
  _getContentSpacingProperties() {
    return { type: "text", colsMdUp: "none" };
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "in-text-teaser",
      interaction_text: this.buttonLabel
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    const imgData = this.image;
    return html`<header>
        <div>${this.kicker ? html`<h4>${this.kicker}</h4>` : nothing}</div>
        <div>
          ${this.onlyMarkets !== void 0 || this.link?.marketUris ? html`<jb-globe-icon></jb-globe-icon><jb-market-display></jb-market-display>` : nothing}
        </div>
      </header>
      <section class=${classMap({ "no-image": !imgData })}>
        ${imgData ? html`<div class="image-wrap">
              <a data-linkable @jb-link:clicked=${this._tracking}></a>
                <jb-picture
                  .imgData=${imgData}
                  aspect="aspect_3by2"
                  fit="cover"
                ></jb-picture>
              </a>
            </div>` : nothing}
        <div class="text-wrap">
          <a
            data-linkable
            @jb-link:clicked=${this._tracking}
          >
            <h3>${this.headline}</h3>
            ${this.text ? html`<p>${this.text}</p>` : nothing}
          </a>
          ${this.buttonLabel ? html`<jb-button-secondary
                .link=${this.link}
                @jb-link:clicked=${this._tracking}
                >${this.buttonLabel}</jb-button-secondary
              >` : nothing}
        </div>
      </section>`;
  }
};
JbInTextTeaser.styles = unsafeCSS(jb_in_text_teaser_default);
__decorateClass([
  property()
], JbInTextTeaser.prototype, "buttonLabel", 2);
__decorateClass([
  property()
], JbInTextTeaser.prototype, "headline", 2);
__decorateClass([
  property({ type: Object })
], JbInTextTeaser.prototype, "image", 2);
__decorateClass([
  property()
], JbInTextTeaser.prototype, "kicker", 2);
__decorateClass([
  property({ type: Array })
], JbInTextTeaser.prototype, "onlyMarkets", 2);
__decorateClass([
  property()
], JbInTextTeaser.prototype, "text", 2);
JbInTextTeaser = __decorateClass([
  customElement("jb-in-text-teaser")
], JbInTextTeaser);

export {
  JbInTextTeaser
};
